<template>
	<div class="credit-pull-container">
		<h3 class="title">Current Credit Pull</h3>
		<div class="suppression-container">
			<div class="wrapper--switch">
				<ToggleSwitch
					class="toggle-switch"
					@click="handleSuppressionClick"
					v-model="isToggled"
					:disabled="disabled"
				/>
				<div class="wrapper--text">
					<span class="bold">Suppress Alerts:</span>
					<span class="font">
						Alerts will be suppressed for {{ daysToSuppress }} days</span
					>
				</div>
			</div>
			<div class="wrapper--date font">
				{{
					isToggled
						? `Alerts for this client are suppressed until ${expirationDate}`
						: ''
				}}
			</div>
		</div>
	</div>
</template>

<script>
import ToggleSwitch from '@/components/global/ToggleSwitch.vue';
export default {
	name: 'ContactCreditSuppression',
	components: {
		ToggleSwitch,
	},
	props: {
		isAlertSuppressed: {
			type: Boolean,
			default: false,
		},
		suppressAlertEndDate: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			isSuppressed: false,
			daysToSuppress: 14,
			/* 
				window.Date.now() returns unix time at the moment it is run, new Date() can accept unix time to get the date
				SO new Date(window.Date.now()) is equivalient to new Date()

				In our test for this component we can mock out Date.now and have it return a date of our choosing
				This way our unit tests will always thnk it's running on same date
			*/
			startDate: new Date(window.Date.now()),
			endDate: '',
		};
	},
	computed: {
		expirationDate() {
			const expire = this.getFormattedDateString(this.endDate);
			return expire;
		},
		isToggled() {
			return !this.disabled && this.isSuppressed;
		},
	},
	created() {
		if (!this.disabled) {
			this.generateEndDate();
			this.isSuppressed = this.isAlertSuppressed;
			this.clearExpiredDate();
		}
	},
	methods: {
		handleSuppressionClick(isOn) {
			if (!this.disabled) {
				this.isSuppressed = isOn;
				if (this.endDate === '') this.generateEndDate();
				if (isOn) {
					this.$emit('handleSuppressionClick', isOn, this.expirationDate);
				} else {
					this.$emit('handleSuppressionClick', isOn, '');
				}
			}
		},
		generateEndDate() {
			this.endDate =
				this.suppressAlertEndDate === ''
					? new Date(
							new Date().setDate(
								this.startDate.getDate() + this.daysToSuppress,
							),
					  )
					: new Date(this.suppressAlertEndDate);
		},
		clearExpiredDate() {
			if (this.startDate.getTime() > this.endDate.getTime()) {
				if (
					this.getFormattedDateString(this.startDate) !==
					this.getFormattedDateString(this.endDate)
				) {
					this.isSuppressed = false;
					this.$emit('clearSuppressionExpiredDate', false, '');
				}
			}
		},
		getFormattedDateString(dateObject) {
			return new Intl.DateTimeFormat('en-US').format(dateObject);
		},
	},
	watch: {
		suppressAlertEndDate() {
			if (!this.disabled) {
				this.generateEndDate();
			}
		},
		isAlertSuppressed() {
			this.isSuppressed = this.isAlertSuppressed;
		},
	},
};
</script>

<style scoped lang="scss">
.title {
	font-weight: 500;
	color: #333;
	margin-bottom: 0.625rem;
	font-size: 1rem;
}

.suppression-container {
	display: flex;
	flex-direction: column;
}

.wrapper {
	&--switch {
		display: flex;
		justify-content: flex-start;
	}
	&--date {
		display: flex;
		align-items: center;
		min-height: 1.5rem;
		padding: 5px;
	}
}

.bold,
.font {
	font-size: 15px;
	line-height: 1;
}

.bold {
	font-weight: 500;
	margin-left: 14px;
}

.toggle-switch.on {
	background-color: $brand-blue;
}
</style>
